jQuery(function($){
    
    // mobile menu toggler
    let menuToggler = $('.nav-primary__toggle__checkbox');
    let menuPrimary = $('.nav-primary');
    // on change of the checkbox
    menuToggler.change(function(){
        $(this).is(':checked') ? menuPrimary.addClass('nav-primary--open') : menuPrimary.removeClass('nav-primary--open');
    });

    // window resize
    $(window).resize(function(){
        if($(window).width() > 900){
            menuPrimary.removeClass('nav-primary--open');
            menuToggler.prop('checked', false);
        }
    });




    // modal
    
    $('.luxe__video-play').click(function(){
        let modal = $(".luxe__video-modal");
        // get attribute data-video-url
        let videoID = $(this).attr('data-video-id');
        // iframe 
        let iframe = $('.luxe__video-modal iframe');
        // set iframe src
        iframe.attr('src', `https://www.youtube.com/embed/${videoID}?autoplay=1`);
        // open modal
        $(modal).addClass("open");
        $("html").addClass('modal-open');
    });



    // close modal

    $('.luxe__video-modal .close').click(function(){

        let modal = $(".luxe__video-modal");
        let iframe = $('.luxe__video-modal iframe');
        // close modal
        iframe.attr('src', '');
        $(modal).removeClass("open");
        $("html").removeClass('modal-open');
    });



})